import '@/app/app.css';
import './catalog.css';

import '@/app/app';
import '@/layouts/main/main';
import { FormInputWithReset } from '@/shared/form/form-element/form-input/form-input-reset';
import { CatalogFilter } from '@/pages/catalog/sections/catalog-filter/catalog-filter';
import { CatalogSlider } from '@/pages/catalog/sections/catalog-slider/catalog-slider';
import { CatalogLayout } from '@/pages/catalog/sections/catalog-layout/catalog-layout';

window.addEventListener('DOMContentLoaded', () => {
	new CatalogSlider(document.querySelector('.js-catalog-slider'));
	new CatalogLayout(document.querySelector('.js-catalog-layout'));
	new CatalogFilter(document.querySelector('.js-catalog-filter'));

	document.querySelectorAll('.catalog-filter-section__search .form-input').forEach((input) => {
		new FormInputWithReset(input);
	});

	document.querySelectorAll('.js-filter-popover').forEach((popover) => {
		new window.app.Popover(popover);
	});

	const filterSwitchers = document.querySelectorAll('.form-checkbox--switcher .form-checkbox__input');
	filterSwitchers.forEach((switcher) => {
		switcher.addEventListener('change', () => {
			const popover = app.classInstance.get(switcher.closest('.js-filter-popover'));
			if (popover) {
				popover.popover.toggle(switcher.checked);
			}
		});
	});
});
